import { render, staticRenderFns } from "./UserStock.vue?vue&type=template&id=bd5ef6aa&scoped=true"
import script from "./UserStock.vue?vue&type=script&lang=js"
export * from "./UserStock.vue?vue&type=script&lang=js"
import style0 from "./UserStock.vue?vue&type=style&index=0&id=bd5ef6aa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd5ef6aa",
  null
  
)

export default component.exports